import React, { useEffect, useState } from "react";

const NAV = [
  { id: "home", label: "HOME" },
  { id: "experience", label: "EXPERIENCE" },
  { id: "projects", label: "PROJECTS" },
  { id: "skills", label: "STACK" },
  { id: "contact", label: "CONTACT" },
];

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-40 transition-colors ${
        scrolled
          ? "border-b border-line bg-bg-base/80 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 font-mono text-[12px] uppercase tracking-[0.22em]">
        <a
          href="#home"
          data-testid="navbar-logo"
          className="flex items-center gap-2 text-ink-primary"
        >
          <span className="inline-block h-2 w-2 rounded-full bg-accent shadow-[0_0_10px_rgba(0,229,255,0.7)]" />
          <span>aryan.sh</span>
        </a>

        <nav className="hidden items-center gap-7 text-ink-secondary md:flex">
          {NAV.slice(1).map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              data-testid={`navbar-link-${n.id}`}
              className="transition hover:text-accent"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="mailto:aryansrivastava0826@gmail.com"
          data-testid="navbar-cta"
          className="btn-terminal hidden border border-accent/60 px-3 py-1.5 text-accent md:inline-flex"
        >
          [ HIRE_ME ]
        </a>
      </div>
    </header>
  );
};

export default NavBar;
